import { NgIf }                                               from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule }                                    from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef }     from '@angular/material/dialog';
import { MatIconModule }                                      from '@angular/material/icon';
import { MatProgressSpinnerModule }                           from '@angular/material/progress-spinner';
import { PushPipe }                                           from '@ngrx/component';
import { Store }                                              from '@ngrx/store';
import { environment }                                        from 'src/environments/environment';
import { ISpinnerState }                                      from '../../../../shared/ngrx/store/state/spinner.state';

@Component ({
              selector:        'app-confirm-rappel-conseiller',
              templateUrl:     './confirm-rappel-conseiller.component.html',
              styleUrls:       ['./confirm-rappel-conseiller.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              standalone:      true,
              imports:         [
                PushPipe,
                MatDialogModule,
                MatButtonModule,
                MatIconModule,
                MatProgressSpinnerModule,
                NgIf,
              ],
              providers:       [],
            })
export class ConfirmRappelConseillerComponent implements OnInit {
  constructor (public dialogRef: MatDialogRef<ConfirmRappelConseillerComponent>,
               public _store: Store<ISpinnerState>,
               @Inject (MAT_DIALOG_DATA) public data: any,
  ) {
  }

  closeDialog () {
    this.dialogRef.close ({ check: true });
  }

  ngOnInit (): void {
  }

}
